<template>
  <figure>
    <svg version="1.1" viewBox="0 0 88 88" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="linearGradient-1" x1="100%" x2="50%" y1="50%" y2="100%">
          <stop offset="0%" stop-color="#005B85" />
          <stop offset="100%" stop-color="#B8D8D8" />
        </linearGradient>
      </defs>
      <g fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
        <g stroke-width="6" transform="translate(-652.000000, -448.000000)">
          <g transform="translate(655.000000, 451.000000)">
            <circle cx="41" cy="41" r="41" stroke="#B8D8D8" />
            <path
              d="M82,41 C82,18.3563253 63.6436747,2.84217094e-14 41,2.84217094e-14 C18.3563253,2.84217094e-14 6.36646291e-11,18.3563253 6.36646291e-11,41 C6.36646291e-11,63.6436747 18.3563253,82 41,82"
              stroke="url(#linearGradient-1)"
              stroke-linecap="round"
              transform="translate(41.000000, 41.000000) rotate(-90.000000) translate(-41.000000, -41.000000)"
            />
          </g>
        </g>
      </g>
    </svg>
  </figure>
</template>

<style scoped>
figure {
  display: flex;
  min-height: 10rem;
  background-color: var(--white);
}

figure svg {
  --size: 82px;
  width: var(--size);
  height: auto;
  font-size: var(--size);
  line-height: var(--size);
  margin: 0 auto calc(var(--size) * 0.5);
  animation: wk-rotate calc(var(--time1) * 6) cubic-bezier(0.79, 0.14, 0.15, 0.86) infinite;
}

@keyframes wk-rotate {
  0% {
    transform: rotate(90deg);
  }

  100% {
    transform: rotate(450deg);
  }
}
</style>
